// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"bb277202","144":"9c8c3ff6","527":"55304c38","787":"6ccac1ff","910":"43be55ea"}[chunkId] + ".chunk.js";
};